// extracted by mini-css-extract-plugin
module.exports = {"news":"styles_news__2RWd5","h2":"styles_h2__Yh59b","p":"styles_p__TLs5z"};